import EditScriptList from './EditScriptList';
export default EditScriptList;
